// Need to address loading and showing for a date all the "other" custom items in the drop down list.
import React, { useState, useRef, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Box,
  Divider, Button,
  IconButton
} from '@mui/material';
import ExcelJS from 'exceljs';
import { Menu, MenuItem } from '@mui/material';
import { AddCircle, RemoveCircle, ListAlt, ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import axios from 'axios';

const inventoryCategories = [
  {
    name: "Clothing",
    items: ["New (with tag)", "Children's Apparel", "Adult Apparel", "Children's Footwear", "Adult Footwear",
      "Accessories, Underwear, Onesies", "Winter Apparel"
    ]
  },
  {
    name: "Linens",
    items: ["New (with tag)", "Small", "Medium", "Large"]
  },
  {
    name: "Equipment",
    items: ["New (with tag)", "Small", "Medium", "Large", "Extra Large"]
  },
  {
    name: "Toiletries",
    items: ["New (with tag)", "Travel Size"]
  },
  {
    name: "Toys",
    items: ["New (with tag)", "Small", "Medium", "Large"]
  },
  {
    name: "Handmade Items",
    items: ["Other", "Hats", "Scarves", "Gloves"]
  }
];

const InventoryList = ({ title, counts, setCounts, otherText, setOtherText }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleDelta = (category, item, delta) => {
    setCounts((prev) => {
      const prevVal = prev?.[title]?.[category]?.[item] ?? 0;
      const newVal = Math.max(0, prevVal + delta);

      return {
        ...prev,
        [title]: {
          ...prev?.[title],
          [category]: {
            ...prev?.[title]?.[category],
            [item]: newVal,
          },
        },
      };
    });
  };

  const handleDirectChange = (category, item, value) => {
    const newValue = Math.max(0, parseInt(value, 10) || 0);
    setCounts((prev) => ({
      ...prev,
      [title]: {
        ...prev?.[title],
        [category]: {
          ...prev?.[title]?.[category],
          [item]: newValue,
        },
      },
    }));
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectOther = (text) => {
    setOtherText(text);
    handleCloseMenu();
  };

  return (
    <Box>
      {inventoryCategories.map((category) => (
        <Box key={category.name} mb={1}>
          <Box width="100%" bgcolor="#1976d2" mb={1} color="white" px={1} py={0} borderRadius={1}>
            <Typography variant="subtitle1" fontWeight="bold">
              {category.name}
            </Typography>
          </Box>

          {category.items.map((item) => {
            const isHandmadeOther = category.name === "Handmade Items" && item === "Other";

            // Correct key logic
            let baseItem = item;
            const extra = (isHandmadeOther && otherText.trim()) ? otherText.trim() : '';
            if (isHandmadeOther && extra) {
              baseItem = `${item} ${extra}`;
            }

            const value = counts?.[title]?.[category.name]?.[baseItem] ?? 0;
            const key = `${category.name}-${item}`;

            // For Handmade Items "Other" dropdown
            const handmadeCounts = counts?.[title]?.["Handmade Items"] || {};
            const otherOptions = Object.keys(handmadeCounts)
              .filter(k => k.startsWith("Other ") && handmadeCounts[k] > 0)
              .map(k => k.slice(6)); // Remove "Other "

            return (

              <Grid
                container
                alignItems="center"
                spacing={1}
                key={key}
                style={{ marginBottom: 8 }}
              >

                {/* IF HANDMADE OTHER */}
                {isHandmadeOther ? (
                  <>
                    <Grid container alignItems="center" spacing={1} style={{ marginLeft: 1, marginTop: 1, marginBottom: 1 }}>
                      {/* ITEM LABEL */}
                      <Grid item xs={isHandmadeOther ? 3 : 6}>
                        <Typography>{item}</Typography>
                      </Grid>

                      {/* Right-aligned controls */}
                      <Grid item xs={9}>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                          {/* Description TextField */}
                          <TextField
                            size="small"
                            placeholder="Description"
                            value={otherText}
                            inputProps={{ maxLength: 64 }}
                            onChange={(e) => setOtherText(e.target.value)}
                            sx={{ width: 140 }}
                          />

                          {/* Menu Icon */}
                          <IconButton size="small" onClick={handleOpenMenu}>
                            <ListAlt />
                          </IconButton>

                          {/* Number Field */}
                          <TextField
                            size="small"
                            value={value}
                            onChange={(e) => {
                              handleDirectChange(category.name, baseItem, e.target.value);
                            }}
                            inputProps={{ min: 0, style: { textAlign: 'right' } }}
                            sx={{ marginLeft: -1, marginRight: 0.2, width: 50, minWidth: 50 }}
                          />

                          {/* +/- Buttons */}
                          <IconButton style={{ marginLeft: -1, marginRight: -8 }}
                            onClick={() => handleDelta(category.name, baseItem, 1)}>
                            <AddCircle />
                          </IconButton>
                          <IconButton onClick={() => handleDelta(category.name, baseItem, -1)}>
                            <RemoveCircle />
                          </IconButton>
                        </Box>

                        {/* Popup Menu */}
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                          {otherOptions.length > 0 ? (
                            otherOptions.map((option, idx) => (
                              <MenuItem key={idx} onClick={() => handleSelectOther(option)}>
                                {option}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No entries yet</MenuItem>
                          )}
                        </Menu>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  /* IF NORMAL ITEM */
                  // NORMAL ITEM (Right-aligned)
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center">
                      {/* Left-aligned label */}
                      <Typography sx={{ flexGrow: 1 }}>{item}</Typography>

                      {/* Right-aligned controls */}
                      <TextField
                        size="small"
                        value={value}
                        onChange={(e) => handleDirectChange(category.name, baseItem, e.target.value)}
                        inputProps={{ min: 0, style: { textAlign: 'right' } }}
                        sx={{ width: 50, mr: 1 }}
                      />
                      <IconButton onClick={() => handleDelta(category.name, baseItem, 1)}>
                        <AddCircle />
                      </IconButton>
                      <IconButton onClick={() => handleDelta(category.name, baseItem, -1)}>
                        <RemoveCircle />
                      </IconButton>
                    </Box>
                  </Grid>
                )}
              </Grid>


            );
          })}
        </Box>
      ))}
    </Box>
  );
};

const InventoryPage = () => {
  const nameRef = useRef(null);
  const dateRef = useRef(null);
  const sourceRef = useRef(null);

  const [csvUrl, setCsvUrl] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    date: new Date().toISOString().split('T')[0],
    source: ''
  });

  const [errors, setErrors] = useState({
    name: false,
    date: false,
    source: false
  });


  const initializeCounts = () => {
    const base = {
      Keep: {},
      GoodWill: {}
    };

    ["Keep", "GoodWill"].forEach((column) => {
      inventoryCategories.forEach((category) => {
        base[column][category.name] = {};
        category.items.forEach((item) => {
          base[column][category.name][item] = 0;
        });
      });
    });

    console.log("Counts Set")

    return base;
  };
  const [counts, setCounts] = useState(initializeCounts);
  const [otherTexts, setOtherTexts] = useState({
    Keep: '',
    GoodWill: ''
  });

  useEffect(() => {
    setCsvUrl('');
  }, [counts]);

  useEffect(() => {
    const fetchSavedInventory = async () => {
      console.log("GETTING DATA FOR DATE")
      const result = await loadInventorySubmissionForDate(formData.date);
      if (result) {
        // Pre-fill form fields
        setFormData(prev => ({
          ...prev,
          name: result.name || '',
          source: result.source || ''
        }));

        // Load the counts
        setCounts(result.counts || initializeCounts());
      } else {
        // If no data, reset to empty
        setCounts(initializeCounts());
      }
    };

    if (formData.date) {
      fetchSavedInventory();
    }
  }, [formData.date]);


  const loadInventorySubmissionForDate = async (date) => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/inventory/load`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const allData = res.data || [];
      const match = allData.find(entry => entry.date === date);

      return match || null;
    } catch (error) {
      console.error('❌ Failed to load inventory:', error.response?.data || error.message);
      return null;
    }
  };


  const saveInventoryForCurrentDate = async () => {
    const token = localStorage.getItem('authToken');

    const now = new Date();
    const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);

    let fullInventory = [];

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/inventory/load`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fullInventory = res.data || [];
    } catch (err) {
      console.warn('⚠️ Failed to load existing inventory. Starting fresh.');
    }

    // Cleaned counts
    const cleanedCounts = {};
    ['Keep', 'GoodWill'].forEach(section => {
      const filtered = {};
      Object.entries(counts?.[section] || {}).forEach(([category, items]) => {
        const validItems = Object.fromEntries(
          Object.entries(items).filter(([, count]) => count > 0)
        );
        if (Object.keys(validItems).length) {
          filtered[category] = validItems;
        }
      });
      if (Object.keys(filtered).length) {
        cleanedCounts[section] = filtered;
      }
    });

    const newEntry = {
      timestamp,
      date: formData.date,
      name: formData.name,
      source: formData.source,
      counts: cleanedCounts
    };

    // Remove any existing entry for the same date
    fullInventory = fullInventory.filter(entry => entry.date !== formData.date);
    fullInventory.push(newEntry);

    try {
      await axios.post(`${process.env.REACT_APP_API_HOST}/inventory/save`, fullInventory, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      console.log('✅ Inventory saved.');
    } catch (err) {
      console.error('❌ Save failed', err);
    }

    return fullInventory;
  };

  const generateExcel = async () => {
    if (!formData.name.trim()) {
      setErrors(prev => ({ ...prev, name: true }));
      window.alert("Name is required");
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const savedInventory = await saveInventoryForCurrentDate();

    // Convert flat array into a month-grouped object
    const monthMap = {};
    savedInventory.forEach(entry => {
      const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
      if (!monthMap[month]) monthMap[month] = [];
      monthMap[month].push(entry);
    });

    const workbook = new ExcelJS.Workbook();
    const inventorySheet = workbook.addWorksheet('Inventory');

    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const now = new Date();
    const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);

    // Build dynamic item lists including custom "Other {desc}" items
    const dynamicItems = {};
    ["Keep", "GoodWill"].forEach(section => {
      dynamicItems[section] = {};
      inventoryCategories.forEach(cat => {
        dynamicItems[section][cat.name] = new Set(cat.items);
      });
    });

    savedInventory.forEach(entry => {
      ["Keep", "GoodWill"].forEach(section => {
        const sectionData = entry.counts?.[section] || {};
        for (const [category, items] of Object.entries(sectionData)) {
          for (const item of Object.keys(items)) {
            if (!dynamicItems[section][category]) {
              dynamicItems[section][category] = new Set();
            }
            dynamicItems[section][category].add(item);
          }
        }
      });
    });

    // Prepare zeroed base structure
    const initializeCounts = () => {
      const base = {
        Keep: {},
        GoodWill: {}
      };
      ["Keep", "GoodWill"].forEach(section => {
        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          base[section][category] = {};
          itemSet.forEach(item => {
            base[section][category][item] = 0;
          });
        }
      });
      return base;
    };

    // Build monthly totals
    const monthlyTotals = {};
    const monthSheets = {};

    months.forEach(month => {
      monthlyTotals[month] = initializeCounts();
      monthSheets[month] = workbook.addWorksheet(month);
    });

    // Fill data
    for (const [month, entries] of Object.entries(monthMap)) {
      entries.forEach(entry => {
        ["Keep", "GoodWill"].forEach(section => {
          const sectionData = entry.counts?.[section] || {};
          for (const [category, items] of Object.entries(sectionData)) {
            for (const [item, count] of Object.entries(items)) {
              if (!monthlyTotals[month][section][category][item]) {
                monthlyTotals[month][section][category][item] = 0;
              }
              monthlyTotals[month][section][category][item] += count;
            }
          }
        });
      });
    }

    // Header and metadata
    const headerRow = inventorySheet.addRow(['', '', '', ...months]);
    months.forEach((_, idx) => {
      const col = 4 + idx;
      const cell = headerRow.getCell(col);
      cell.font = { bold: true };
      cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
    });
    inventorySheet.addRow([]);

    ["Keep", "GoodWill"].forEach(section => {
      const sectionRow = inventorySheet.addRow([section]);
      const totalColumns = 3 + months.length;
      for (let col = 1; col <= totalColumns; col++) {
        const cell = sectionRow.getCell(col);
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
        };
      }

      for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
        const categoryRow = inventorySheet.addRow(['', category]);
        const firstCol = 2;
        const lastCol = 3 + months.length;
        for (let col = firstCol; col <= lastCol; col++) {
          const cell = categoryRow.getCell(col);
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        }
        months.forEach((_, idx) => {
          const col = 4 + idx;
          const cell = categoryRow.getCell(col);
          cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
        });

        Array.from(itemSet).forEach(item => {
          const row = ['', '', item];
          months.forEach(month => {
            const value = monthlyTotals[month]?.[section]?.[category]?.[item] || 0;
            row.push(value);
          });
          const itemRow = inventorySheet.addRow(row);
          months.forEach((_, idx) => {
            const col = 4 + idx;
            const cell = itemRow.getCell(col);
            const value = cell.value;
            cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
            if (typeof value === 'number' && value > 0) {
              cell.font = { bold: true };
            }
          });
        });
      }
    });

    inventorySheet.views = [{ state: 'frozen', ySplit: 1, xSplit: 3 }];
    inventorySheet.columns = [
      { width: 20 },
      { width: 20 },
      { width: 30 },
      ...months.map(m => ({ width: m.length + 2 }))
    ];

    for (const [month, entries] of Object.entries(monthMap)) {
      const sheet = monthSheets[month];
      const sortedEntries = [...entries].sort((a, b) => new Date(a.date) - new Date(b.date));
      const dayColumns = sortedEntries.map(e =>
        `${e.date}\nName: ${e.name || ''}\nSource: ${e.source || ''}`
      );
      const header = sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
      header.eachCell(cell => {
        cell.font = { bold: true };
        cell.alignment = { wrapText: true };
      });
      header.eachCell(cell => cell.font = { bold: true });

      ["Keep", "GoodWill"].forEach(section => {
        const sectionRow = sheet.addRow([section]);
        sectionRow.eachCell(cell => {
          cell.font = { bold: true };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
          };
        });

        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          const categoryRow = sheet.addRow(['', category]);
          categoryRow.eachCell(cell => cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F2F2F2' }
          });

          Array.from(itemSet).forEach(item => {
            const row = ['', '', item];
            sortedEntries.forEach(entry => {
              const count = entry.counts?.[section]?.[category]?.[item] || 0;
              row.push(count);
            });
            const itemRow = sheet.addRow(row);
            itemRow.eachCell((cell, colNumber) => {
              if (colNumber > 3) {
                cell.border = {
                  left: { style: 'thin' },
                  right: { style: 'thin' }
                };
                if (typeof cell.value === 'number' && cell.value > 0) {
                  cell.font = { bold: true };
                }
              }
            });
          });
        }
      });

      sheet.views = [{ state: 'frozen', ySplit: 1, xSplit: 3 }];
      sheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 30 },
        ...dayColumns.map(day => {
          const lines = day.split('\n');
          const maxLineLength = Math.max(...lines.map(line => line.length));
          return { width: maxLineLength + 2 };
        })
      ];
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = URL.createObjectURL(blob);
    setCsvUrl(`${url}#${Date.now()}`);
  };
  /*
    const generateExcelAllGoodPreNameSourceOnMonthSheets = async () => {
      if (!formData.name.trim()) {
        setErrors(prev => ({ ...prev, name: true }));
        window.alert("Name is required");
        nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
  
      const savedInventory = await saveInventoryForCurrentDate();
  
      // Convert flat array into a month-grouped object
      const monthMap = {};
      savedInventory.forEach(entry => {
        const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
        if (!monthMap[month]) monthMap[month] = [];
        monthMap[month].push(entry);
      });
  
      const workbook = new ExcelJS.Workbook();
      const inventorySheet = workbook.addWorksheet('Inventory');
  
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
  
      const now = new Date();
      const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);
  
      // Build dynamic item lists including custom "Other {desc}" items
      const dynamicItems = {};
      ["Keep", "GoodWill"].forEach(section => {
        dynamicItems[section] = {};
        inventoryCategories.forEach(cat => {
          dynamicItems[section][cat.name] = new Set(cat.items);
        });
      });
  
      savedInventory.forEach(entry => {
        ["Keep", "GoodWill"].forEach(section => {
          const sectionData = entry.counts?.[section] || {};
          for (const [category, items] of Object.entries(sectionData)) {
            for (const item of Object.keys(items)) {
              if (!dynamicItems[section][category]) {
                dynamicItems[section][category] = new Set();
              }
              dynamicItems[section][category].add(item);
            }
          }
        });
      });
  
      // Prepare zeroed base structure
      const initializeCounts = () => {
        const base = {
          Keep: {},
          GoodWill: {}
        };
        ["Keep", "GoodWill"].forEach(section => {
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            base[section][category] = {};
            itemSet.forEach(item => {
              base[section][category][item] = 0;
            });
          }
        });
        return base;
      };
  
      // Build monthly totals
      const monthlyTotals = {};
      const monthSheets = {};
  
      months.forEach(month => {
        monthlyTotals[month] = initializeCounts();
        monthSheets[month] = workbook.addWorksheet(month);
      });
  
      // Fill data
      for (const [month, entries] of Object.entries(monthMap)) {
        entries.forEach(entry => {
          ["Keep", "GoodWill"].forEach(section => {
            const sectionData = entry.counts?.[section] || {};
            for (const [category, items] of Object.entries(sectionData)) {
              for (const [item, count] of Object.entries(items)) {
                if (!monthlyTotals[month][section][category][item]) {
                  monthlyTotals[month][section][category][item] = 0;
                }
                monthlyTotals[month][section][category][item] += count;
              }
            }
          });
        });
      }
  
      // Header and metadata
      inventorySheet.addRow([`Name: ${formData.name}`, `Date: ${formData.date}`, `Source: ${formData.source}`]);
      const headerRow = inventorySheet.addRow(['', '', '', ...months]);
      months.forEach((_, idx) => {
        const col = 4 + idx;
        const cell = headerRow.getCell(col);
        cell.font = { bold: true };
        cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
      });
      inventorySheet.addRow([]);
  
      ["Keep", "GoodWill"].forEach(section => {
        const sectionRow = inventorySheet.addRow([section]);
        const totalColumns = 3 + months.length;
        for (let col = 1; col <= totalColumns; col++) {
          const cell = sectionRow.getCell(col);
          cell.font = { bold: true };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
          };
        }
  
        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          const categoryRow = inventorySheet.addRow(['', category]);
          const firstCol = 2;
          const lastCol = 3 + months.length;
          for (let col = firstCol; col <= lastCol; col++) {
            const cell = categoryRow.getCell(col);
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
          }
          months.forEach((_, idx) => {
            const col = 4 + idx;
            const cell = categoryRow.getCell(col);
            cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
          });
  
          Array.from(itemSet).forEach(item => {
            const row = ['', '', item];
            months.forEach(month => {
              const value = monthlyTotals[month]?.[section]?.[category]?.[item] || 0;
              row.push(value);
            });
            const itemRow = inventorySheet.addRow(row);
            months.forEach((_, idx) => {
              const col = 4 + idx;
              const cell = itemRow.getCell(col);
              cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
            });
          });
        }
      });
  
      // Monthly sheets
      inventorySheet.views = [{ state: 'frozen', ySplit: 2, xSplit: 3 }];
      inventorySheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 30 },
        ...months.map(m => ({ width: m.length + 2 }))
      ];
  
      for (const [month, entries] of Object.entries(monthMap)) {
        const sheet = monthSheets[month];
        const sortedEntries = [...entries].sort((a, b) => new Date(a.date) - new Date(b.date));
        const dayColumns = sortedEntries.map(e => e.date);
        const header = sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
        header.eachCell(cell => cell.font = { bold: true });
  
        ["Keep", "GoodWill"].forEach(section => {
          const sectionRow = sheet.addRow([section]);
          sectionRow.eachCell(cell => {
            cell.font = { bold: true };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
            };
          });
  
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            const categoryRow = sheet.addRow(['', category]);
            categoryRow.eachCell(cell => cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'F2F2F2' }
            });
  
            Array.from(itemSet).forEach(item => {
              const row = ['', '', item];
              sortedEntries.forEach(entry => {
                const count = entry.counts?.[section]?.[category]?.[item] || 0;
                row.push(count);
              });
              const itemRow = sheet.addRow(row);
              itemRow.eachCell((cell, colNumber) => {
                if (colNumber > 3) {
                  cell.border = {
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                  };
                }
              });
            });
          }
        });
  
        sheet.views = [{ state: 'frozen', ySplit: 1, xSplit: 3 }];
        sheet.columns = [
          { width: 20 },
          { width: 20 },
          { width: 30 },
          ...dayColumns.map(day => ({ width: day.length + 2 }))
        ];
      }
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      setCsvUrl(`${url}#${Date.now()}`);
    };
  
    const generateExcelAllSheetsStyledGood = async () => {
      const savedInventory = await saveInventoryForCurrentDate();
  
      // Convert flat array into a month-grouped object
      const monthMap = {};
      savedInventory.forEach(entry => {
        const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
        if (!monthMap[month]) monthMap[month] = [];
        monthMap[month].push(entry);
      });
  
      const workbook = new ExcelJS.Workbook();
      const inventorySheet = workbook.addWorksheet('Inventory');
  
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
  
      const now = new Date();
      const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);
  
      // Build dynamic item lists including custom "Other {desc}" items
      const dynamicItems = {};
      ["Keep", "GoodWill"].forEach(section => {
        dynamicItems[section] = {};
        inventoryCategories.forEach(cat => {
          dynamicItems[section][cat.name] = new Set(cat.items);
        });
      });
  
      savedInventory.forEach(entry => {
        ["Keep", "GoodWill"].forEach(section => {
          const sectionData = entry.counts?.[section] || {};
          for (const [category, items] of Object.entries(sectionData)) {
            for (const item of Object.keys(items)) {
              if (!dynamicItems[section][category]) {
                dynamicItems[section][category] = new Set();
              }
              dynamicItems[section][category].add(item);
            }
          }
        });
      });
  
      // Prepare zeroed base structure
      const initializeCounts = () => {
        const base = {
          Keep: {},
          GoodWill: {}
        };
        ["Keep", "GoodWill"].forEach(section => {
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            base[section][category] = {};
            itemSet.forEach(item => {
              base[section][category][item] = 0;
            });
          }
        });
        return base;
      };
  
      // Build monthly totals
      const monthlyTotals = {};
      const monthSheets = {};
  
      months.forEach(month => {
        monthlyTotals[month] = initializeCounts();
        monthSheets[month] = workbook.addWorksheet(month);
      });
  
      // Fill data
      for (const [month, entries] of Object.entries(monthMap)) {
        entries.forEach(entry => {
          ["Keep", "GoodWill"].forEach(section => {
            const sectionData = entry.counts?.[section] || {};
            for (const [category, items] of Object.entries(sectionData)) {
              for (const [item, count] of Object.entries(items)) {
                if (!monthlyTotals[month][section][category][item]) {
                  monthlyTotals[month][section][category][item] = 0;
                }
                monthlyTotals[month][section][category][item] += count;
              }
            }
          });
        });
      }
  
      // Header and metadata
      inventorySheet.addRow([`Name: ${formData.name}`, `Date: ${formData.date}`, `Source: ${formData.source}`]);
      const headerRow = inventorySheet.addRow(['', '', '', ...months]);
      months.forEach((_, idx) => {
        const col = 4 + idx;
        const cell = headerRow.getCell(col);
        cell.font = { bold: true };
        cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
      });
      inventorySheet.addRow([]);
  
      ["Keep", "GoodWill"].forEach(section => {
        const sectionRow = inventorySheet.addRow([section]);
        const totalColumns = 3 + months.length;
        for (let col = 1; col <= totalColumns; col++) {
          const cell = sectionRow.getCell(col);
          cell.font = { bold: true };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
          };
        }
  
        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          const categoryRow = inventorySheet.addRow(['', category]);
          const firstCol = 2;
          const lastCol = 3 + months.length;
          for (let col = firstCol; col <= lastCol; col++) {
            const cell = categoryRow.getCell(col);
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
          }
          months.forEach((_, idx) => {
            const col = 4 + idx;
            const cell = categoryRow.getCell(col);
            cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
          });
  
          Array.from(itemSet).forEach(item => {
            const row = ['', '', item];
            months.forEach(month => {
              const value = monthlyTotals[month]?.[section]?.[category]?.[item] || 0;
              row.push(value);
            });
            const itemRow = inventorySheet.addRow(row);
            months.forEach((_, idx) => {
              const col = 4 + idx;
              const cell = itemRow.getCell(col);
              cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
            });
          });
        }
      });
  
      // Monthly sheets
      inventorySheet.views = [{ state: 'frozen', ySplit: 2, xSplit: 3 }];
      inventorySheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 30 },
        ...months.map(m => ({ width: m.length + 2 }))
      ];
  
      for (const [month, entries] of Object.entries(monthMap)) {
        const sheet = monthSheets[month];
        const dayColumns = entries.map(e => e.date);
        const header = sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
        header.eachCell(cell => cell.font = { bold: true });
  
        ["Keep", "GoodWill"].forEach(section => {
          const sectionRow = sheet.addRow([section]);
          sectionRow.eachCell(cell => {
            cell.font = { bold: true };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
            };
          });
  
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            const categoryRow = sheet.addRow(['', category]);
            categoryRow.eachCell(cell => cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'F2F2F2' }
            });
  
            Array.from(itemSet).forEach(item => {
              const row = ['', '', item];
              entries.forEach(entry => {
                const count = entry.counts?.[section]?.[category]?.[item] || 0;
                row.push(count);
              });
              const itemRow = sheet.addRow(row);
              itemRow.eachCell((cell, colNumber) => {
                if (colNumber > 3) {
                  cell.border = {
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                  };
                }
              });
            });
          }
        });
  
        sheet.views = [{ state: 'frozen', ySplit: 1, xSplit: 3 }];
        sheet.columns = [
          { width: 20 },
          { width: 20 },
          { width: 30 },
          ...dayColumns.map(day => ({ width: day.length + 2 }))
        ];
      }
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      setCsvUrl(`${url}#${Date.now()}`);
    };
  
    const generateExcelWithStylingGood = async () => {
      const savedInventory = await saveInventoryForCurrentDate();
  
      // Convert flat array into a month-grouped object
      const monthMap = {};
      savedInventory.forEach(entry => {
        const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
        if (!monthMap[month]) monthMap[month] = [];
        monthMap[month].push(entry);
      });
  
      const workbook = new ExcelJS.Workbook();
      const inventorySheet = workbook.addWorksheet('Inventory');
  
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
  
      const now = new Date();
      const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);
  
      // Build dynamic item lists including custom "Other {desc}" items
      const dynamicItems = {};
      ["Keep", "GoodWill"].forEach(section => {
        dynamicItems[section] = {};
        inventoryCategories.forEach(cat => {
          dynamicItems[section][cat.name] = new Set(cat.items);
        });
      });
  
      savedInventory.forEach(entry => {
        ["Keep", "GoodWill"].forEach(section => {
          const sectionData = entry.counts?.[section] || {};
          for (const [category, items] of Object.entries(sectionData)) {
            for (const item of Object.keys(items)) {
              if (!dynamicItems[section][category]) {
                dynamicItems[section][category] = new Set();
              }
              dynamicItems[section][category].add(item);
            }
          }
        });
      });
  
      // Prepare zeroed base structure
      const initializeCounts = () => {
        const base = {
          Keep: {},
          GoodWill: {}
        };
        ["Keep", "GoodWill"].forEach(section => {
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            base[section][category] = {};
            itemSet.forEach(item => {
              base[section][category][item] = 0;
            });
          }
        });
        return base;
      };
  
      // Build monthly totals
      const monthlyTotals = {};
      const monthSheets = {};
  
      months.forEach(month => {
        monthlyTotals[month] = initializeCounts();
        monthSheets[month] = workbook.addWorksheet(month);
      });
  
      // Fill data
      for (const [month, entries] of Object.entries(monthMap)) {
        entries.forEach(entry => {
          ["Keep", "GoodWill"].forEach(section => {
            const sectionData = entry.counts?.[section] || {};
            for (const [category, items] of Object.entries(sectionData)) {
              for (const [item, count] of Object.entries(items)) {
                if (!monthlyTotals[month][section][category][item]) {
                  monthlyTotals[month][section][category][item] = 0;
                }
                monthlyTotals[month][section][category][item] += count;
              }
            }
          });
        });
      }
  
      // Header and metadata
      inventorySheet.addRow([`Name: ${formData.name}`, `Date: ${formData.date}`, `Source: ${formData.source}`]);
      const headerRow = inventorySheet.addRow(['', '', '', ...months]);
      months.forEach((_, idx) => {
        const col = 4 + idx;
        const cell = headerRow.getCell(col);
        cell.font = { bold: true };
        cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
      });
      inventorySheet.addRow([]);
  
      ["Keep", "GoodWill"].forEach(section => {
        const sectionRow = inventorySheet.addRow([section]);
        const totalColumns = 3 + months.length;
        for (let col = 1; col <= totalColumns; col++) {
          const cell = sectionRow.getCell(col);
          cell.font = { bold: true };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: section === 'Keep' ? 'C6EFCE' : 'FFD8B1' }
          };
        }
  
        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          const categoryRow = inventorySheet.addRow(['', category]);
          const firstCol = 2;
          const lastCol = 3 + months.length;
          for (let col = firstCol; col <= lastCol; col++) {
            const cell = categoryRow.getCell(col);
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
          }
          months.forEach((_, idx) => {
            const col = 4 + idx;
            const cell = categoryRow.getCell(col);
            cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
          });
  
          Array.from(itemSet).forEach(item => {
            const row = ['', '', item];
            months.forEach(month => {
              const value = monthlyTotals[month]?.[section]?.[category]?.[item] || 0;
              row.push(value);
            });
            const itemRow = inventorySheet.addRow(row);
            months.forEach((_, idx) => {
              const col = 4 + idx;
              const cell = itemRow.getCell(col);
              cell.border = { left: { style: 'thin' }, right: { style: 'thin' } };
            });
          });
        }
      });
  
      // Monthly sheets
      inventorySheet.views = [{ state: 'frozen', ySplit: 2, xSplit: 3 }];
      inventorySheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 30 },
        ...months.map(m => ({ width: m.length + 2 }))
      ];
  
      for (const [month, entries] of Object.entries(monthMap)) {
        const sheet = monthSheets[month];
        const dayColumns = entries.map(e => e.date);
        sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
  
        ["Keep", "GoodWill"].forEach(section => {
          sheet.addRow([section]);
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            sheet.addRow(['', category]);
            Array.from(itemSet).forEach(item => {
              const row = ['', '', item];
              entries.forEach(entry => {
                const count = entry.counts?.[section]?.[category]?.[item] || 0;
                row.push(count);
              });
              sheet.addRow(row);
            });
          }
        });
      }
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      setCsvUrl(`${url}#${Date.now()}`);
    };
  
    const generateExcelNowWithOther = async () => {
      const savedInventory = await saveInventoryForCurrentDate();
  
      // Convert flat array into a month-grouped object
      const monthMap = {};
      savedInventory.forEach(entry => {
        const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
        if (!monthMap[month]) monthMap[month] = [];
        monthMap[month].push(entry);
      });
  
      const workbook = new ExcelJS.Workbook();
      const inventorySheet = workbook.addWorksheet('Inventory');
  
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
  
      const now = new Date();
      const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);
  
      // Build dynamic item lists including custom "Other {desc}" items
      const dynamicItems = {};
      ["Keep", "GoodWill"].forEach(section => {
        dynamicItems[section] = {};
        inventoryCategories.forEach(cat => {
          dynamicItems[section][cat.name] = new Set(cat.items);
        });
      });
  
      savedInventory.forEach(entry => {
        ["Keep", "GoodWill"].forEach(section => {
          const sectionData = entry.counts?.[section] || {};
          for (const [category, items] of Object.entries(sectionData)) {
            for (const item of Object.keys(items)) {
              if (!dynamicItems[section][category]) {
                dynamicItems[section][category] = new Set();
              }
              dynamicItems[section][category].add(item);
            }
          }
        });
      });
  
      // Prepare zeroed base structure
      const initializeCounts = () => {
        const base = {
          Keep: {},
          GoodWill: {}
        };
        ["Keep", "GoodWill"].forEach(section => {
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            base[section][category] = {};
            itemSet.forEach(item => {
              base[section][category][item] = 0;
            });
          }
        });
        return base;
      };
  
      // Build monthly totals
      const monthlyTotals = {};
      const monthSheets = {};
  
      months.forEach(month => {
        monthlyTotals[month] = initializeCounts();
        monthSheets[month] = workbook.addWorksheet(month);
      });
  
      // Fill data
      for (const [month, entries] of Object.entries(monthMap)) {
        entries.forEach(entry => {
          ["Keep", "GoodWill"].forEach(section => {
            const sectionData = entry.counts?.[section] || {};
            for (const [category, items] of Object.entries(sectionData)) {
              for (const [item, count] of Object.entries(items)) {
                if (!monthlyTotals[month][section][category][item]) {
                  monthlyTotals[month][section][category][item] = 0;
                }
                monthlyTotals[month][section][category][item] += count;
              }
            }
          });
        });
      }
  
      // Build inventory sheet header
      inventorySheet.addRow([`Generated: ${timestamp}`]);
      const header = ['Section', 'Category', 'Item', ...months];
      inventorySheet.addRow(header);
  
      ["Keep", "GoodWill"].forEach(section => {
        inventorySheet.addRow([section]);
        for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
          inventorySheet.addRow(['', category]);
          Array.from(itemSet).forEach(item => {
            const row = ['', '', item];
            months.forEach(month => {
              const value = monthlyTotals[month]?.[section]?.[category]?.[item] || 0;
              row.push(value);
            });
            inventorySheet.addRow(row);
          });
        }
      });
  
      // Populate month-specific sheets
      for (const [month, entries] of Object.entries(monthMap)) {
        const sheet = monthSheets[month];
        const dayColumns = entries.map(e => e.date);
        sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
  
        ["Keep", "GoodWill"].forEach(section => {
          sheet.addRow([section]);
          for (const [category, itemSet] of Object.entries(dynamicItems[section])) {
            sheet.addRow(['', category]);
            Array.from(itemSet).forEach(item => {
              const row = ['', '', item];
              entries.forEach(entry => {
                const count = entry.counts?.[section]?.[category]?.[item] || 0;
                row.push(count);
              });
              sheet.addRow(row);
            });
          }
        });
      }
  
      // Finalize export
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      setCsvUrl(`${url}#${Date.now()}`);
    };
  
    const generateExcelOldGood = async () => {
      const savedInventory = await saveInventoryForCurrentDate();
  
      // Convert flat array into a month-grouped object
      const monthMap = {};
      savedInventory.forEach(entry => {
        const month = new Date(entry.date).toLocaleString('en-US', { month: 'long' });
        if (!monthMap[month]) monthMap[month] = [];
        monthMap[month].push(entry);
      });
  
      const workbook = new ExcelJS.Workbook();
      const inventorySheet = workbook.addWorksheet('Inventory');
  
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
  
      const now = new Date();
      const timestamp = now.toISOString().replace('T', ' ').substring(0, 16);
  
      // Prepare zeroed base structure
      const initializeCounts = () => {
        const base = {
          Keep: {},
          GoodWill: {}
        };
        ["Keep", "GoodWill"].forEach(section => {
          inventoryCategories.forEach(category => {
            base[section][category.name] = {};
            category.items.forEach(item => {
              base[section][category.name][item] = 0;
            });
          });
        });
        return base;
      };
  
      // Build monthly totals
      const monthlyTotals = {};
      const monthSheets = {};
  
      months.forEach(month => {
        monthlyTotals[month] = initializeCounts();
        monthSheets[month] = workbook.addWorksheet(month);
      });
  
      // Fill data
      for (const [month, entries] of Object.entries(monthMap)) {
        entries.forEach(entry => {
          ["Keep", "GoodWill"].forEach(section => {
            const sectionData = entry.counts?.[section] || {};
            for (const [category, items] of Object.entries(sectionData)) {
              for (const [item, count] of Object.entries(items)) {
                if (!monthlyTotals[month][section][category][item]) {
                  monthlyTotals[month][section][category][item] = 0;
                }
                monthlyTotals[month][section][category][item] += count;
              }
            }
          });
        });
      }
  
      // Build inventory sheet header
      inventorySheet.addRow([`Generated: ${timestamp}`]);
      const header = ['Section', 'Category', 'Item', ...months];
      inventorySheet.addRow(header);
  
      ["Keep", "GoodWill"].forEach(section => {
        inventorySheet.addRow([section]);
        inventoryCategories.forEach(category => {
          inventorySheet.addRow(['', category.name]);
          category.items.forEach(item => {
            const row = ['', '', item];
            months.forEach(month => {
              const value = monthlyTotals[month]?.[section]?.[category.name]?.[item] || 0;
              row.push(value);
            });
            inventorySheet.addRow(row);
          });
        });
      });
  
      // Populate month-specific sheets
      for (const [month, entries] of Object.entries(monthMap)) {
        const sheet = monthSheets[month];
        const dayColumns = entries.map(e => e.date);
        sheet.addRow(['Section', 'Category', 'Item', ...dayColumns]);
  
        ["Keep", "GoodWill"].forEach(section => {
          sheet.addRow([section]);
          inventoryCategories.forEach(category => {
            sheet.addRow(['', category.name]);
            category.items.forEach(item => {
              const row = ['', '', item];
              entries.forEach(entry => {
                const count = entry.counts?.[section]?.[category.name]?.[item] || 0;
                row.push(count);
              });
              sheet.addRow(row);
            });
          });
        });
      }
  
      // Finalize export
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = URL.createObjectURL(blob);
      setCsvUrl(`${url}#${Date.now()}`);
    };
  */
  return (
    <Container maxWidth="lg" style={{ marginTop: '2rem' }}>
      <Paper elevation={3} style={{ padding: 10 }}>
        <Typography variant="h4" gutterBottom>
          Inventory Tracker
        </Typography>

        <Grid container spacing={1} style={{ marginTop: 0 }}>
          <Grid item xs={12} md={4}>

            <TextField fullWidth variant="outlined"
              inputRef={nameRef}
              label="Name"
              value={formData.name}
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
                if (e.target.value.trim()) {
                  setErrors(prev => ({ ...prev, name: false }));
                }
              }}
              error={errors.name}
              helperText={errors.name ? "Name is required" : ""}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              inputRef={dateRef}
              label="Date"
              type="date"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              error={errors.date}
              helperText={errors.date ? "Date is required" : ""}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              inputRef={sourceRef}
              fullWidth
              variant="outlined"
              label="Source"
              value={formData.source}
              onChange={(e) => setFormData({ ...formData, source: e.target.value })}
              error={errors.source}
              helperText={errors.source ? "Source is required" : ""}
            />
          </Grid>
        </Grid>

        <Divider style={{ margin: 10 }} />
        <Box display="flex" justifyContent="center" mb={0}>
          <Typography variant="subtitle1" fontWeight="bold">
            You do not have to count items you throw away!
          </Typography>
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
              Keep
            </Typography>
            <Box border="1px dashed gray" padding="1rem" minHeight="200px">
              <InventoryList title="Keep" counts={counts} setCounts={setCounts} otherText={otherTexts.Keep}
                setOtherText={(text) => setOtherTexts(prev => ({ ...prev, Keep: text }))} />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
              Given To Good Will
            </Typography>
            <Box border="1px dashed gray" padding="1rem" minHeight="200px">
              <InventoryList title="GoodWill" counts={counts} setCounts={setCounts} otherText={otherTexts.GoodWill}
                setOtherText={(text) => setOtherTexts(prev => ({ ...prev, GoodWill: text }))} />
            </Box>
          </Grid>
        </Grid>

        <Box mt={4} display="flex" justifyContent="center" gap={2}>
          <Button variant="contained" color="primary" size="large" onClick={generateExcel}>
            Submit
          </Button>

          {csvUrl && (
            <a href={csvUrl} download="TickSheet.xlsx" style={{ alignSelf: 'center' }}>
              Download Excel Workbook
            </a>
          )}
        </Box>

        {false &&
          <>
            <Typography variant="body" gutterBottom>
              {JSON.stringify(formData)}
            </Typography>
            <Typography variant="body" gutterBottom>
              {JSON.stringify(counts)}
            </Typography>
          </>
        }

        {false &&
          <Box mt={4} p={2} bgcolor="#f5f5f5" borderRadius={2}>
            <Typography variant="h6">Debug Counts</Typography>
            <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '0.8rem' }}>
              {JSON.stringify(counts, null, 2)}
            </pre>
          </Box>
        }

      </Paper>
    </Container>
  );
};

export default InventoryPage;
